<svg-icon
  *ngIf="!isFavorite"
  class="icon"
  src="./assets/icons/heart.svg"
  (click)="addProductToList(); $event.stopPropagation()"
></svg-icon>
<svg-icon
  *ngIf="isFavorite"
  class="icon"
  src="./assets/icons/heart-filled.svg"
  (click)="addProductToList(); $event.stopPropagation()"
></svg-icon>
